import React from 'react';
import { Star, Globe, ThumbsUp, Heart } from 'lucide-react';
const testimonials = [{
  name: 'Pastor Roberto Mendoza',
  role: 'Líder de Iglesia, Ciudad de México',
  quote: 'He comprado docenas de comentarios bíblicos y cursos online, y este material es claramente el mejor que existe en el mercado en todos los aspectos. Tiene una profundidad increíble pero con un lenguaje que cualquier persona puede entender. Las explicaciones versículo por versículo son detalladas y las aplicaciones prácticas cambiaron mi forma de predicar.',
  time: '1 d',
  likes: 252,
  avatarBg: '#7C5C2E'
}, {
  name: 'María Elena Contreras',
  role: 'Líder de Grupo de Estudio, Bogotá',
  quote: 'Recibí este material hace unos días y no he podido dejarlo. Hay explicaciones claras con contexto completo de cada epístola. ¡Resultó ser aún mejor de lo que esperaba! Las explicaciones son súper fáciles de leer y comprender, a diferencia de otros materiales que encontré por internet.',
  time: '2 d',
  likes: 189,
  avatarBg: '#4A7C59'
}, {
  name: 'Hermano Daniel Gutiérrez',
  role: 'Estudiante de Teología, Lima, Perú',
  quote: 'De todos los materiales bíblicos que he comprado a lo largo de los años, esta es la mejor colección que tengo. Es un recurso excelente tanto para principiantes como para predicadores experimentados. Me habría encantado tener esto cuando empecé a predicar hace 15 años.',
  time: '3 d',
  likes: 341,
  avatarBg: '#5C4A8A'
}, {
  name: 'Carlos Eduardo Ramírez',
  role: 'Diácono, Santiago, Chile',
  quote: 'He gastado dinero en materiales que prometían mucho y entregaban poco, pero este recurso me demostró que estaba equivocado y no podría estar más contento con la compra. Para un principiante, este paquete es un regalo del cielo porque obtienes cada detalle que necesitas.',
  time: '5 d',
  likes: 178,
  avatarBg: '#8A4A2E'
}];
export function Testimonials() {
  return <section className="py-12 md:py-16 relative" style={{
    background: '#F6F1E7'
  }} data-id="element-269">
      <div className="container mx-auto px-4 max-w-2xl relative z-10" data-id="element-270">
        {/* Section heading */}
        <div className="text-center mb-6" data-id="element-271">
          <h2 className="text-2xl md:text-3xl font-serif font-bold mb-2" style={{
          color: '#1C1C1C'
        }} data-id="element-272">
            Lo Que Dicen Nuestros Estudiantes
          </h2>
          <div className="mx-auto w-20 gold-divider" data-id="element-273" />
        </div>

        {/* Aggregate rating card */}
        <div className="rounded-2xl p-5 mb-5 text-center" style={{
        background: '#FBF8F2',
        border: '1px solid rgba(200,169,106,0.25)',
        boxShadow: '0 2px 16px rgba(60,40,10,0.06)'
      }} data-id="element-274">
          <div className="flex items-center justify-center gap-3 mb-1" data-id="element-275">
            <span className="text-5xl font-black" style={{
            color: '#1C1C1C',
            fontFamily: 'Merriweather, serif'
          }} data-id="element-276">
              4.9
            </span>
            <div className="flex gap-0.5" data-id="element-277">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-current" style={{
              color: '#C8A96A'
            }} data-id="element-278" />)}
            </div>
          </div>
          <p className="text-sm font-bold mb-1" style={{
          color: '#3A3020'
        }} data-id="element-279">
            Basado en <strong data-id="element-280">+2.400 estudiantes</strong>
          </p>
          <div className="inline-flex items-center gap-1.5 text-xs px-3 py-1 rounded-full" style={{
          background: 'rgba(200,169,106,0.12)',
          border: '1px solid rgba(200,169,106,0.3)',
          color: '#7A6030'
        }} data-id="element-281">
            {/* Facebook-style verified badge */}
            <span className="inline-flex items-center justify-center w-4 h-4 rounded-full text-white font-black text-[9px]" style={{
            background: '#1877F2',
            lineHeight: 1
          }} data-id="element-282">
              f
            </span>
            Reseñas verificadas
          </div>
        </div>

        {/* Facebook-style comment cards */}
        <div className="space-y-3" data-id="element-283">
          {testimonials.map((t, i) => <div key={i} className="rounded-2xl overflow-hidden" style={{
          background: '#FBF8F2',
          border: '1px solid rgba(200,169,106,0.2)',
          boxShadow: '0 2px 12px rgba(60,40,10,0.05)'
        }} data-id="element-284">
              <div className="p-4" data-id="element-285">
                {/* Header: avatar + name + meta */}
                <div className="flex items-start gap-3 mb-3" data-id="element-286">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center text-sm font-black flex-shrink-0" style={{
                background: t.avatarBg,
                color: '#FFFFFF',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
              }} data-id="element-287">
                    {t.name.split(' ').slice(0, 2).map(n => n[0]).join('')}
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-288">
                    <p className="font-bold text-sm leading-tight" style={{
                  color: '#1C1C1C'
                }} data-id="element-289">
                      {t.name}
                    </p>
                    <div className="flex items-center gap-1 text-xs mt-0.5" style={{
                  color: '#9A9A9A'
                }} data-id="element-290">
                      <span data-id="element-291">{t.time}</span>
                      <span data-id="element-292">·</span>
                      <Globe className="w-3 h-3" data-id="element-293" />
                    </div>
                  </div>
                </div>

                {/* Stars */}
                <div className="flex gap-0.5 mb-2" data-id="element-294">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" style={{
                color: '#C8A96A'
              }} data-id="element-295" />)}
                </div>

                {/* Quote */}
                <p className="text-sm leading-relaxed" style={{
              color: '#3A3020'
            }} data-id="element-296">
                  {t.quote}
                </p>
              </div>

              {/* Reaction bar */}
              <div className="px-4 py-2.5 flex items-center justify-between" style={{
            borderTop: '1px solid rgba(200,169,106,0.15)',
            background: 'rgba(200,169,106,0.04)'
          }} data-id="element-297">
                {/* Reaction count */}
                <div className="flex items-center gap-1.5" data-id="element-298">
                  <div className="flex -space-x-1" data-id="element-299">
                    <span className="inline-flex items-center justify-center w-5 h-5 rounded-full text-[10px]" style={{
                  background: '#1877F2'
                }} data-id="element-300">
                      👍
                    </span>
                    <span className="inline-flex items-center justify-center w-5 h-5 rounded-full text-[10px]" style={{
                  background: '#E0284F'
                }} data-id="element-301">
                      ❤️
                    </span>
                  </div>
                  <span className="text-xs font-medium" style={{
                color: '#7A7A7A'
              }} data-id="element-302">
                    {t.likes}
                  </span>
                </div>

                {/* Actions */}
                <div className="flex items-center gap-3 text-xs font-semibold" style={{
              color: '#7A7A7A'
            }} data-id="element-303">
                  <span data-id="element-304">Me gusta</span>
                  <span style={{
                color: 'rgba(200,169,106,0.5)'
              }} data-id="element-305">
                    ·
                  </span>
                  <span data-id="element-306">Responder</span>
                  <span style={{
                color: 'rgba(200,169,106,0.5)'
              }} data-id="element-307">
                    ·
                  </span>
                  <span data-id="element-308">{t.time}</span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}